import type { ReactNode } from "react";
import { Button } from "../shadcn/Button";

export function ErrorState({
  message,
  onRetry,
  title,
  retryLabel = "Try again",
  children,
}: {
  message: string;
  onRetry?: () => void;
  title?: string;
  retryLabel?: string;
  children?: ReactNode;
}) {
  return (
    <div role="alert" className="space-y-3 rounded-[20px] border border-danger/40 bg-danger-surface px-5 py-7 text-center text-sm text-danger">
      {title && <h2 className="text-[21px] font-bold">{title}</h2>}
      <p>{message}</p>
      {children}
      {onRetry && <Button variant="outline" onClick={onRetry}>{retryLabel}</Button>}
    </div>
  );
}
